export const AUTH_CHANNEL = 'auth_channel';
